<template>
  <div>
    <Nav isActive="Test"/>    
    <div class="pageWD mT20" >
      <div>   
        <el-row :gutter="20">
          <el-col :span="6" >       
             <div :class="isScroll?'shadowBox  scrollCsss':'shadowBox '" >
              <div class="mainTop f18 c3">答题卡</div>
                <div class="cardItem">
                  <div class="st flex"><span class="f16 c3 s1">未答</span><span  class="f16 c3 s2">已答</span></div>
                  <div v-if="list_dx.length > 0">                    
                    <div class="flex flexitem"  :style="{'height':leftht+'px'}" >                                                 
                      <div class="item" v-for="(item,index) in list_dx" :key="index" :class="[item.answer=='1'?'select':'']" @click="goAnchor('#choose'+item.QT_Index)">{{item.QT_Index}}</div> 
                    </div>                      
                  </div>                  
                </div>
            </div>   
             <div class="minHeight" style="width:285px"></div>            
            </el-col>
            <el-col :span="18">    
              <div class="shadowBox minHeight" v-if="pageData">
                  <div class="mainTop f18 c3">{{pageData.info.exTitle}}</div>
                  <div class="subItems" v-for="(item,index) in questions" :key="index" :id="'choose'+(index+1)">
                      <div class="subl">
                          <div class="title single">
                              <span class="d">{{item.QT_Index}}.</span>
                              <span class="t">单选题</span>
                              <span class="d" v-html="item.QT_Content"></span>                          
                          </div>
                          <div class="items" >                         
                              <el-radio-group v-model="item.AN_Content" @change="changeType(item.QT_Index,item.AN_Content,item.GN_Index)" >
                                <div v-for="(_item,index) in item.items" :key="index" > 
                                  <el-radio :label="_item.score">{{_item.siContent}}</el-radio>
                                </div>
                              </el-radio-group>
                          </div>
                                          
                      </div>                    
                </div>             
              </div>         
          </el-col>
        </el-row>    
    </div> 
   </div>
<div style="height:92px"></div>   
   <div class="cardFotter" >
       <div class="pageWD" style="text-align:right;padding-top:13px">
         <el-button type="primary"  style="width:83px" @click="subForm">提交</el-button>
       </div>
   </div>
<div style="position:fixed;left:0;top:0;right:0;bottom:0;width:100%;height:100%; opacity: 0.5;
background: #000;overflow:hidden; z-index:4"  v-if="dialogVisible" ></div>
<div class="fixdalert" v-if="dialogVisible">
    <div class="dep" :style="{width:imgWt,height:imgHt}">
      <div class="closex">
        <i class="iconfont icon-a-5_guanbi" @click="tapHide" style="color:#ccc;background:#fff;border-radius:50%;font-size:24px"></i>
      </div>
       <div class="resultOne" v-if="total_score > 90">
         <img src="../../assets/images/test/jingong.jpg" />
         <div class="rt">
          <div class="p1">正面进攻型</div>
          <div class="p2"><span style="color:#000">特征：</span>进攻性强,乐观,防守心弱,企业主攻手,喜欢直接公关,对事情评价一般较高。这类人的管理风格是关系管理、激励、正面管理。</div>
         </div>
       </div>

      <div class="resultOne" v-if="total_score <= 90 && total_score > 64">
         <img src="../../assets/images/test/sikao.jpg" />
         <div class="rt">
          <div class="p1">正面思考型</div>
          <div class="p2"><span style="color:#000">特征：</span>阳光,先看到事情好的一面,再看到事情不好的一面,乐观在前,消极在后。这类人的管理风格是职业化、制度化。</div>
         </div>
       </div>

      <div class="resultOne" v-if=" total_score <= 64 && total_score > 50">
         <img src="../../assets/images/test/jdsk.jpg" />
         <div class="rt">
          <div class="p1">监督思考型</div>
          <div class="p2"><span style="color:#000">特征：</span>消极在前,乐观在后,思维稳重,需要建立信任感,具有监督气质。这类人的管理风格是精细化、分工化。</div>
         </div>
       </div>
       <div class="resultOne" v-if=" total_score <= 50">
         <img src="../../assets/images/test/fangshou.jpg" />
         <div class="rt">
          <div class="p1">监督防守型</div>
          <div class="p2"><span style="color:#000">特征：</span>认真,防守性强,监督能力强,能看到不足之处,心细。这类人的管理风格是任务型、被激励型。</div>
         </div>
       </div>

        <div class="dd">
			    	<div class="zoushi">从价值需求中分析未来三年走势</div>
            <div  class="resultTwo">
            	<div class="twTitle">财政指数：{{wl_score[0]}}</div>
            	<div class="resultText" >
            		<span>特征：</span>通过努力工作获得财富自由。工作当中属于上山型:营销风格。
            	</div>
            </div>
            <div  class="resultTwo">
            	<div class="twTitle">品味指数：{{wl_score[1]}}</div>
            	<div class="resultText" >
            		<span>特征：</span>通过团队管理获得事业成就。工作当中属于平路型:管理领导风格,能带领团队进行工作或职能管理的工作特征。
            	</div>
            </div>
            <div  class="resultTwo">
            	<div class="twTitle">生活指数：{{wl_score[2]}}</div>
            	<div class="resultText" >
            		<span>特征：</span>通过成长管理获得生活自由。工作当中属于下山型:技术风格,能通过工作与生活平衡达到自由的工作特征。
            	</div>
            </div>
        </div>     
         <div class="fbtn">
          <el-button type="primary"  style="width:60%;height:44px;font-size:20px;margin:0px 10px ; border:0;color:#4B8BFB;background:#fff" @click="tapRet">重新测评</el-button>
          <el-button type="primary"  style="width:20%;height:44px;font-size:20px;margin:0px auto" @click="tapClose">关闭</el-button>
          </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
var testData2 = require('@/assets/testdata2.json');
import Cookies from "js-cookie";
import {fieldSave} from '@/api/api'
import Nav from "../../components/Nav.vue";
export default {  
  components: { Nav}, 
   data() {
      return {   
        total_score:0,
        wl_score:  [0,0,0],
        dialogVisible:false,
        pageTestData:null,
        LeaveIndex :true,
        type1:null,
        maxtime:'',
        msg:'',
        Letter:["","A","B","C","D","E","F","G","H","I","J","K","L","M","N"],        
        showtype:false,
        tiId:this.$route.query.taskTI_ID,
        exId:this.$route.query.liId,
        pageData:null,
        percent_:'',
        hg:'',
        zdsc:'',
        list_dx:[],
        list_dd:[],
        list_pd:[],
        list_tk:[],
        list_jd:[],
        questions:[],
        heightNum:null,
        imgHt:null,
        imgWt:null,
        leftht:null,
        isScroll:false
      };
    },
    created() {    
      console.log(testData2)
      this.pageData = testData2.body.result    
      this.questions = this.pageData.questions
      this.questions.forEach(function(item) { 
                if(item.AN_Content){
                  item.AN_Content = null
                }
       })       
      this.getExamCardFun()
      this.heightNum = document.documentElement.clientHeight
      var ht =  document.documentElement.clientHeight - 70       
      var b = 843/ht
      this.imgWt = parseInt(710/b)+'px'
      this.imgHt = ht +'px'     
      this.leftht = (parseInt(this.heightNum) -270)

    },
     mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {  
      handleScroll () {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
           
            if (scrollTop > 200) {
                  this.isScroll = true
              } else {
                  this.isScroll = false
              }
        }, 
      goAnchor(selector) {//参数selector是id选择器（#anchor14）
          document.querySelector(selector).scrollIntoView({
              behavior: "smooth"
          });             
      },
      changeType(QT_Index,AN_Content,GN_Index){
            var that = this       
            this.list_dx.forEach(function(item) { 
              if(item.QT_Index == QT_Index){
                  item.answer='1';
                  item.AN_Content = AN_Content;
                  item.GN_Index = GN_Index
              }
            })         
                    
      } , 
      tapRet(){
        this.$router.go(0) 
      },
      getMaxIndex(arr) {
        var max = arr[0];       
        var index = 0;
        for (var i = 0; i < arr.length; i++) {
            if (max < arr[i]) {
                max = arr[i];
                index = i;
            }
        }
        return index;
      },
      subForm(){
          var that = this
          var len = 0
          this.list_dx.forEach(function(item) { 
            if(item.answer == '1'){
                len++
            }
          })  
          console.log(len)
          if(len == this.list_dx.length){
                this.list_dx.forEach(function(item) { 
                    // 思考模式总分                    
                    var scoreNumber = Number(item.AN_Content);
                    that.total_score += scoreNumber;                    
                    var _thisIndex = item.GN_Index
                    
                    //财政指数 
                    if( _thisIndex == 1 || _thisIndex == 4 || _thisIndex == 5 || _thisIndex == 8){
                      var czTrend = Number(scoreNumber);
                      that.wl_score[0] += czTrend;
                    };
                    
                    // 品味指数
                    if( _thisIndex == 5 || _thisIndex == 6 || _thisIndex == 7 || _thisIndex == 8){
                      var pwTrend = Number(scoreNumber);
                      that.wl_score[1] += pwTrend;
                    };
                    
                    // 生活指数
                    if( _thisIndex == 2 || _thisIndex == 3 || _thisIndex == 6 || _thisIndex == 7){
                      var shTrend = Number(scoreNumber);
                      that.wl_score[2] += shTrend;
                    };
                })                    
                var data = {
                    memberId :Cookies.get('qslmemberId'),
                    sort : 2,
                    coId : Cookies.get('qslCOID'),
                    type: that.total_score+'|'+ that.wl_score[0] +'|'+that.wl_score[1]+'|'+that.wl_score[2]
                }
                console.log(data)
                fieldSave(data)
                .then(res => {           
                     console.log(res)
                      if(res.code=='200'){
                           that.dialogVisible = true
                          // that.type1 = that.getMaxIndex(numArr)
                                                         
                      }else{
                          that.$message('提交失败，请重试！')
                      }
                })
                .catch(err => {});
          }else{
               this.$confirm('当前题目没有完成，请选择！', '提示', {
                  confirmButtonText: '确定',
                  showCancelButton:false,     
                      
                  type: 'warning'
                })
          }
      },
      subForms(){
        var that = this
          var contentArr = []    
          this.questions.forEach(function(item) { 
                if(item.QT_Type =='2'){
                  var AN_Content = item.AN_Content_Arr.toString()
                }else{
                   var AN_Content = item.AN_Content.toString()
                }
                var tempData = 
                {
                  stid:item.QT_ID,
                  content:AN_Content
                }
                contentArr.push(tempData)
          })                
          var that = this
          var data = {
            memberId :Cookies.get('qslmemberId'),
            tiId : that.tiId ,
            content:JSON.stringify(contentArr),
            coId: Cookies.get('qslCOID') 
          } 
          saveAllAnswer(data)
          .then(res => {           
            that.LeaveIndex = false
            this.$router.go(-1);
          })
          .catch(err => {});
      } ,
      tapClose(){
       this.$router.push({path:'/test'});
      },
       tapHide(){
         this.dialogVisible = false
      },
      goAnchor(selector) {
          document.querySelector(selector).scrollIntoView({
              behavior: "smooth"
          });             
      },
      temp_arr(QT_Answer){
        var QT_Arr = QT_Answer.split('|') 
        var temp_arr = ''
        for(var i=0;i<QT_Arr.length;i++){
            var ii = QT_Arr[i]
            temp_arr+= Letter[ii]
        }
        return(temp_arr)        
      },
      getExamCardFun(){
            var that =this
             let listItems = this.questions
             listItems.forEach(function(item) { 
               var data =
                {
                  "re": 0,
                  "QT_Type": 1,
                   "answer": 0,
                  "GN_Index": 0,
                  "AN_Content": 0,
                  "QT_Index": item.QT_Index
                }                                
                  that.list_dx.push(data)             
                
              })           

      },

    }
  };
</script>
<style scoped>


>>> .el-dialog{
  background:transparent;border:0;box-shadow:none
}
.subItems{
  font-size:14px;
  display:flex;
  padding:14px 24px 0 24px
}
.subItems .subl{
  width:670px;
  margin-right:60px
}
.subItems .items{
  color:#333333;
  line-height:22px;
}
.subItems .items div{
  margin:10px 0
}
.color_red{
  color:#F7413F
}
.color_blue{
  color:#4B9AFB
}
.subItems .res{
  width: 668px;
  height: 46px;
  line-height:46px;
  background: #f0f0f0;
  border-radius: 8px;
  margin-top:20px
}
.subItems .res2{
  padding:24px;
  background: #f0f0f0;
  line-height:22px;
  color:#ccc
}

>>>.el-textarea__inner
{
  width: 668px;
  height: 184px;
  background: #f0f0f0;
  border: 1px solid #dddddd;
  border-radius: 8px;
  padding:24px;
  font-size:14px;
}
.subItems .res span{
  padding:0 20px
}
 p{
  display:inline
}
.subItems .subr{
  flex:1;
  font-size:14px;
  color:#333;
  font-weight:bold
}
.subItems .title{
  margin-bottom:14px;
  line-height:24px
}
.subItems .d{
  font-size:14px;
  color:#333;
  font-weight:bold;
}
.subItems .s{
  color:#999;
  font-size:14px;
  margin-left:50px
}
.subItems .t{
  width: 44px;
  height: 19px;
  background: rgba(255,255,255,0.00);
  border: 1px solid #4b9afb;
  border-radius: 2px;
  font-size:12px;
  color:#4B9AFB;
  line-height:21px;
  padding:2px 3px
}
.cardItem{
padding:24px
}
.cardItem .t{
  margin:3px 0 15px 0;
}

.cardItem .item{
  width: 40px;
  height: 40px;
  background: #f0f0f0;
  border: 1px solid #dddddd;
  border-radius: 4px;
  margin-right: 15px;
  margin-bottom:15px;
  font-size:14px;
  color:#333;
  text-align: center;
  line-height: 40px;
   cursor: pointer;
}
.cardItem .select{
  color:#4B9AFB;
  border:1px solid #4B9AFB;
  background: #e4f0fe;
}
.cardItem .flex{ 
  flex-direction: row;
  flex-wrap: wrap;
 
}
.flexitem{
   overflow-y:scroll
}
.cardItem .st span{
  position: relative;
  flex:1;
  padding-left:20px;
  padding-bottom:15px
}
.cardItem .st span::before{
  content: '';
  position:absolute;
  left:0px;
  top:6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.cardItem .st .s1::before{ 
  background: #f0f0f0;
}
.cardItem .st .s2::before{ 
  background: #4B9AFB;
}
.cardFotter{
  height: 72px;
  background: #ffffff;
  width:100%;
  position: fixed;
  bottom:0;
  left:0;right: 0;
}

.ksjg{
  background:#F0F0F0;
  margin:24px;
  padding:40px
}
.ksjg .flex{
  margin-bottom:40px ;  
}
.ksjg .flex div{
  flex:1
}
.ckjg{
  text-align:center;
  padding:16px 0 40px 0
}

.el-button{
  font-size:18px;
  padding:14px 20px
}
.etime{
  color:#F7413F;
  font-size:14px;
  margin-left:24px
}
.dep{
  background:url(../../assets/images/res2.png) no-repeat;
  background-size:cover;
  margin:35px auto;
  position:relative
}

.jiedu .l{
  font-size:28px;
  color:#333;
  border-top:1px dotted #ccc;
  padding:20px 0
}
.jiedu .d{
  text-align:left;
  
}
.resultOne{
  border-bottom:1px dotted #4B9AFB;  padding:15% 0 20px 0;
  margin:0 10%;align-items:center;
  display:flex
}
.resultOne img{
  width:105px; 
}
.resultOne .rt{
  flex:1;
  padding-left:20px;
 
  text-align:left
}
.resultOne .rt .p1{
  color:#4B9AFB;
  font-size:30px;
  padding:0px 0 10px 0
}
.resultOne .rt .p2{
  font-size:20px;line-height: 30px;
  color:#666
}
.zoushi{
   font-size:30px; color:#333;padding:3% 0 2% 0; text-align:center
}
.resultTwo{
  font-size:18px; text-align:left;margin:0 10%; line-height:180%
}
.twTitle{
  color:#4B9AFB;
  padding-top:2%;padding-bottom:1%
}
.resultText span{
  color:#000
}
>>> .el-radio__label{
  width: 700px;
  display: inline-block;
}
.fbtn{
  position:absolute;
  left:0px;
  width:100%;
  bottom:3%;
  right:0;
  text-align:center
}
.scrollCsss{
  position:fixed;width:285px;z-index:4;top:20px;bottom:90px
}
.fbtn >>>.el-button{
  padding:0
}
.fixdalert{
  position:fixed;
  top:0;
  left:0;
  right:0;
  bottom:0;
  width:100%;
  height:100%; 
  z-index:5
}
.closex{
  position:absolute;
  right:-20px;
  top:0
}
</style>


// WEBPACK FOOTER //
// src/views/Test/individual.vue